/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
// components/sections/WeightSection.tsx

import { FloatingLabelNumberInput } from '@ahm/react-ui';
import { Stack, Title, Text, rem } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { useEffect, useMemo, useState } from 'react';
import { useBookingStore } from '@/stores/booking/booking-store-provider';

interface WeightSectionProps {
  error: string | null;
  onChange: (value: number | string) => void;
  onBlur?: () => void;
}

const WeightSection = ({ error, onChange, onBlur }: WeightSectionProps) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const { bikePackageWeight, createOrderError } = useBookingStore(
    (state) => state
  );
  const [weightState, setWeightState] = useState(bikePackageWeight);

  useEffect(() => {
    bikePackageWeight && setWeightState(bikePackageWeight);
  }, [bikePackageWeight]);

  const isWeightCreateOrderError = useMemo(() => {
    return Boolean(
      createOrderError === 'package-detail' && (!weightState || error)
    );
  }, [createOrderError, error, weightState]);

  return (
    <Stack
      gap={8}
      px="md"
      py={rem(6)}
      bg={isWeightCreateOrderError ? 'red.0' : 'white'}
    >
      <Title order={isMobile ? 6 : 4} size={isMobile ? 'sm' : 'md'}>
        Khối lượng (kg)
        <Text component="span" c="red">
          *
        </Text>
      </Title>

      <FloatingLabelNumberInput
        id="weight-section"
        hideControls
        allowNegative={false}
        value={weightState}
        onChange={onChange}
        onBlur={onBlur}
        label="Nhập khối lượng"
        error={error}
      />
    </Stack>
  );
};

export default WeightSection;
